/* eslint-disable eqeqeq */ /* eslint-disable @typescript-eslint/no-unused-vars
*/ /* eslint-disable no-undef */ /* eslint-disable no-undef */ /* eslint-disable
@typescript-eslint/no-empty-function */
<template>
  <!-- <script type="application/javascript" defer src="https://scripts.pay.bka.sh/versions/1.0.000-beta/checkout/bKash-checkout.js"></script> -->
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Payment Status</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Payment Status</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid text-center">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <div class="login-form success-box">
              <img src="../../../public/img/icon-success.svg" alt="success" />
              <h1>Successful</h1>
              <p>{{ paymentStatus }}</p>

              <router-link
                :to="{ name: 'dashboard' }"
                custom
                v-slot="{ href, navigate, isActive }"
              >
                <a class="btn btn-full" :href="href" @click="navigate">
                  Go to dashboard
                </a>
              </router-link>
              <!-- <a href="#" class="btn btn-full">Go to dashboard</a> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<style scoped>
li.payableAmount::before {
  content: "";
}
.bkash-step p {
  letter-spacing: 0.25px;
  margin-bottom: 30px;
}
.bkash-step ul li {
  display: block;
  border-radius: 30px;
  background: #c50258;
  margin: 15px 0;
  counter-increment: listNumber;
  letter-spacing: 0.25px;
  font-size: 1rem;
  line-height: 1.75rem;
  padding: 5px;
}
.bkash-step ul li::before {
  content: counter(listNumber);
  display: inline-block;
  vertical-align: middle;
  font-size: 24px;
  color: #111;
  background: #fff;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  text-align: center;
  margin-right: 10px;
  line-height: 40px;
}
</style>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI } from "@/services/api";
import { Notification } from "element-ui";
const fileDownload = require("js-file-download");

export default {
  name: "DataUsage",
  metaInfo: {
    title: "Ticket History | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    paymentStatus: "",
  }),
  // method is called after page load
  mounted: function () {
    // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click')
    // }

    if (
      this.$route.query.tnxStatus === "SUCCESS" ||
      this.$route.query.tnxStatus === "success"
    ) {
      this.paymentStatus = "Congrats!, Payment Successfully Completed.";
    } else if (this.$route.query.tnxStatus === "Failed") {
      this.paymentStatus =
        "Payment Failed!, Please contact with respective concern.";
    } else if (this.$route.query.tnxStatus === "Canceled") {
      this.paymentStatus = "Your Payment Canceled.";
    } else {
      this.paymentStatus = this.$route.query.tnxStatus;
    }
  },

  methods: {
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },
  },
};
</script>
